/** Match backend `normalizeRoleSlug` / JWT role values */
export const normalizeRoleSlug = (role) =>
  String(role ?? "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

/** System admin bypasses locked /app screen checks (menu + API). */
export const isUnrestrictedAdminRole = (role) => {
  const slug = normalizeRoleSlug(role);
  return slug === "admin" || slug === "super-admin";
};

export const SYSTEM_ADMIN_ROLE_ID = 1;
export const SYSTEM_ADMIN_USER_BUILDER_SUBMODULE_SLUG = "user-control";
/** Main module slug (User builder screen lives here). */
export const SYSTEM_ADMIN_USER_MANAGEMENT_MODULE_SLUG = "main";

/** Only User builder is fixed for admin — other Main screens stay editable. */
export const isProtectedAdminUserManagementRow = (roleId, row) =>
  Number(roleId) === SYSTEM_ADMIN_ROLE_ID &&
  String(row?.submodule_slug ?? "").trim() ===
    SYSTEM_ADMIN_USER_BUILDER_SUBMODULE_SLUG;

/** Seeded system administrator in User builder (tbl_users id=1). */
export const SYSTEM_ADMIN_USER_ID = 1;
export const SYSTEM_ADMIN_USER_CODE = "ADMIN001";

const PROTECTED_SYSTEM_ROLE_SLUGS = new Set(["admin", "donor", "students"]);
const PROTECTED_PORTAL_ROLE_SLUGS = new Set(["donor", "students"]);

export const isReservedSystemRoleSlug = (slug) =>
  PROTECTED_SYSTEM_ROLE_SLUGS.has(normalizeRoleSlug(slug));

export const isSystemRoleRow = (row) => {
  if (!row) return false;
  if (Number(row.is_system) === 1) return true;
  return isReservedSystemRoleSlug(row.role_slug);
};

export const isProtectedPortalRoleUser = (row) =>
  PROTECTED_PORTAL_ROLE_SLUGS.has(normalizeRoleSlug(row?.role_slug));

export const isProtectedSystemAdminUser = (row) => {
  if (!row) return false;
  // Set by backend listUsersPaginated using ADMIN_EMAIL from server env
  if (row.is_protected === 1 || row.is_protected === true) return true;
  if (Number(row.id) === SYSTEM_ADMIN_USER_ID) return true;
  const code = String(row.user_code ?? "")
    .trim()
    .toUpperCase();
  if (code === SYSTEM_ADMIN_USER_CODE) return true;
  return false;
};

/** Accounts that cannot be edited or removed in User builder. */
export const isProtectedUserBuilderAccount = (row) =>
  isProtectedSystemAdminUser(row) || isProtectedPortalRoleUser(row);
